import { useEventStore } from '@/stores/EventStore'
import { Task } from '@/classes/Task'
import router from '@/router'
import { useEmployeeStore } from '@/stores/EmployeeStore'
import { computed } from 'vue'
import { useAuthStore } from '@/stores/AuthStore'

const route = computed(() => router.currentRoute.value)
export function navigateToCurrentTaskPage(considerStatefulPages = false) {
  if (considerStatefulPages && route.value.meta.isStateful) return
  const eventStore = useEventStore()
  const authStore = useAuthStore()
  const employeeStore = useEmployeeStore()
  const { employee } = employeeStore
  //get last event ignoring workplan events like legal-breaks
  let lastEvent
  if (useAuthStore().isTeamDevice) {
    lastEvent = eventStore.lastTeamEvent
  } else {
    lastEvent = eventStore.lastEventOfEmployee(employee?.id, true, true)
  }
  if (!lastEvent) {
    return router.replace({ name: 'home' })
  }
  if (authStore.isTeamDevice && !employeeStore.teamleader) {
    return router.replace({ name: 'home' })
  }
  switch (lastEvent.task_id) {
    case Task.id.CLOCKOUT:
      return router.replace({ name: 'home' })
    case Task.id.PROJECT:
      return router.replace({
        name: 'project',
        params: { id: lastEvent.project_id },
      })

    case Task.id.WORK:
      return router.replace({ name: 'home' })
    default:
      return router.replace({
        name: 'task',
        params: {
          id: lastEvent.task_id,
          projectId: lastEvent.project_id || '',
        },
      })
  }
}
